import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

const PARTS_OF_TOKEN = 3;

@Injectable({ providedIn: 'root' })
export class TokenDecoderService {
  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  decodeToken(token: any): any {
    if (!this.tokenIsValid(token)) {
      return {};
    }

    return this.getPartOfToken(token);
  }

  private getPartOfToken(token: string): any {
    const partOfToken = token.split('.')[1];
    const result = this.urlBase64Decode(partOfToken);
    return JSON.parse(result);
  }

  private urlBase64Decode(str: string): string {
    let output = str.replace(/-/g, '+').replace(/_/g, '/');

    switch (output.length % 4) {
      case 0:
        break;
      case 2:
        output += '==';
        break;
      case 3:
        output += '=';
        break;
      default:
        throw Error('Illegal base64url string!');
    }

    const decoded =
      typeof this.document.defaultView !== 'undefined'
        ? this.document.defaultView.atob(output)
        : Buffer.from(output, 'base64').toString('binary');

    try {
      // Going backwards: from byte stream, to percent-encoding, to original string.
      return decodeURIComponent(
        decoded
          .split('')
          .map((c: string) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
    } catch (err) {
      return decoded;
    }
  }

  private tokenIsValid(token: string): boolean {
    if (!token || !(token as string).includes('.')) {
      return false;
    }

    const parts = token.split('.');
    return parts.length === PARTS_OF_TOKEN;
  }
}
